import { calculateMetricsAcrossDays } from "app/lib/utils/adaya/ProviderUtils";
import { createDayArray, createIsoTimeRange, mapDaysBetweenDates } from "app/lib/utils/DateUtils";

// Each tab corresponds to a dateArray
export const tabOptions = {
    'last7days': { label: '7 days', labelLong: 'Last 7 Days' },
    'last30days': { label: '30 days', labelLong: 'Last 30 Days' },
    'monthToDate': { label: 'MTD', labelLong: 'Month to Date' },
    'quarterToDate': { label: 'QTD', labelLong: 'Quarter to Date' },
    'yearToDate': { label: 'YTD', labelLong: 'Year to Date' }
};

export enum TabState {
    Loading = 'Loading',
    Loaded = 'Loaded',
    Error = 'Error'
}

export const NEW_TAB_STATE = (tab) => {
    return {
        label: tabOptions[tab].label,
        labelLong: tabOptions[tab].labelLong,
        state: TabState.Loading,
        data: undefined, // the raw data for the range
        merPrediction: undefined,
        error: undefined,
        totals: {}, // misc stats to be shown on ie. summary/tabs
        timeRange: undefined // convenience to pass around later (not used)
    }
}

// Todo: change to use Metric enum.
export const defaultMetricItems = [
    { value: 'mer', label: 'MER' },
    { value: 'breakdown', label: 'Revenue / Adspend' },
    { value: 'roas', label: 'MER (After Returns)' },
];

export const predictionMetricItems = [
    { value: 'prediction', label: 'MER Prediction' }
];

export const getInitialTabStates = () => {
    let states = {};
    Object.keys(tabOptions).forEach(tab => {
        states[tab] = NEW_TAB_STATE(tab);
    });
    return states;
}

export const formatMer = (mer) => {
    return mer === Infinity ? '0.00' : mer.toFixed(2);
};
